// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"a8755d0d","453":"ac9b7e2a","832":"fe8e4fcf"}[chunkId] + ".chunk.js";
};